exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".other-court-info table tbody tr:last-child td{border-bottom:0}.other-court-info .case-label{text-align:center;margin:20px 0}.other-court-info .messages{margin-bottom:30px}.other-court-info .live_search{margin-top:15px;margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/case/associated_cases/OtherCourtInfo.less
// module id = 1608
// module chunks = 0